var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"home",attrs:{"align-v":"end"}},[_c('b-col',[_c('LanguageSelection',{staticClass:"selection"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }